import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";

const SurveyFormHeader = ({
  canManage,
  isPublished,
  submitting,
  loadingSurvey,
  isEdit,
}) => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Button
        type="button"
        variant="ghost"
        onClick={() => navigate(PATHS.SURVEYS)}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        {t("Back to Surveys")}
      </Button>
      {canManage && !isPublished ? (
        <Button type="submit" disabled={submitting || loadingSurvey}>
          {submitting
            ? t("Saving...")
            : isEdit
              ? t("Update Survey")
              : t("Save Survey")}
        </Button>
      ) : null}
    </div>
  );
};

export default SurveyFormHeader;
